import React from "react";
import Automationone from "../components/Section/Engine-&-transmission-one"
import Automationtwo from "../components/Section/Engine-&-transmission-two"

function Automation() {
 

  return (
    <div className="bg-[#0C2341] mx-4 min-h-screen mt-2">
    
        <Automationone />
        <Automationtwo />
      
    </div>
  );
}

export default Automation;